{
    "comment_slider.its_complicated": "Unentschlossen",
    "rating.its_complicated": "Unentschlossen",
    "reaction_types.nuanced": "Komplex"
}
